import { Box } from '@mui/material'

import type React from 'react'

import { MenuFilterCategory } from '../../domain/menu-category-filter'
import { MenuItemFilterSections } from '../../domain/menu-item-filter'
import { BackToSupplierButton } from '../back-to-supplier'
import MenuItemSearch from './menu-item-search'
import MenuFilters from './MenuFilters'

interface SearchAndFilterMenuProps {
  filterCategories?: MenuFilterCategory[]
  loading: boolean
  filterSections?: MenuItemFilterSections
  hideFilterButton?: React.ReactNode
}

export const SearchAndFilterMenu: React.FC<SearchAndFilterMenuProps> = ({
  filterCategories,
  loading,
  filterSections,
  hideFilterButton,
}) => {
  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', position: 'relative' }}>
      <Box
        sx={{
          position: 'sticky',
          top: { xs: 0, lg: '80px' },
          zIndex: 1,
          paddingY: 2,
          backgroundColor: 'background.paper',
        }}>
        {hideFilterButton}
        <BackToSupplierButton />
        <MenuItemSearch />
      </Box>

      <Box sx={{ flex: 1, overflow: 'auto', scrollbarWidth: 'thin' }}>
        <MenuFilters
          filterSections={filterSections}
          filterCategories={filterCategories}
          loading={loading}
        />
      </Box>
    </Box>
  )
}
